import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import get from 'lodash/get';

import Grid from '../../../components/molecules/Grid';
import Link from '../../atoms/Link';
import useStyles from './style';
import Typography from '../../atoms/Typography';
import IconWithText from '../../molecules/IconWithText';
import {
  pushAnaylyticsData,
  createDynamicLabels,
} from '../../../../utils/analytics';
import { analyticsData } from '../../../../constants/Analytics/analytics-data';

const PopularSearch = forwardRef((props, ref) => {
  let {
    popularSearch,
    // onPopularSeachClick,
    pageName,
    componentName,
  } = props;

  const classes = useStyles();
  const { listItems, title } = popularSearch && popularSearch.fields;

  const addAnalyticsInfo = text => {
    const obj = {
      ...get(analyticsData, 'pageBodyInteraction.arrowClick'),
      ...{
        label: createDynamicLabels([
          pageName,
          componentName,
          `${title && title.value} - ${text}`,
        ]),
      },
    };
    pushAnaylyticsData(obj);
  };

  const onLinkClick = (e, cta) => {
    addAnalyticsInfo(get(cta, 'value.text', ''));
    // e.preventDefault();
    // onPopularSeachClick(cta);
  };

  const popTitleElem = useRef(null),
    popLinksWrapper = useRef(null);

  useImperativeHandle(ref, () => ({
    popTitleElem,
    popLinksWrapper,
  }));

  const renderPopularLinks = listItems => {
    return listItems.map((link, index) => {
      const { cta } = link.fields || '';
      const linkValue = get(cta, 'value.text', '');
      return linkValue ? (
        <Link
          key={index}
          className={classes.pageLinks}
          link={cta}
          onClick={e => onLinkClick(e, cta)}
        >
          <IconWithText
            iconType="ArrowForwardSharpIcon"
            iconWithCircle={false}
            isAnimate={true}
          >
            <Typography
              component="div"
              variant="body2Bold"
              animateSettings={{
                selfTrigger: false,
                willAnimate: false,
                duration: '250ms',
              }}>
              <Text field={{ value: linkValue }} />
            </Typography>
          </IconWithText>
        </Link>
      ) : null;
    });
  };

  return (
    <Grid item>
      {title && (
        <Typography
          className={classes.subTitle}
          variant="h5Bold"
          component="h2"
          noWrap
          ref={popTitleElem}
          animateSettings={{
            selfTrigger: false,
            willAnimate: true,
            rotateReversed: true,
            duration: '300ms',
          }}
        >
          <Text field={title} />
        </Typography>
      )}
      <Grid item className={classes.pagesLinkSection} ref={popLinksWrapper}>
        {listItems && listItems.length > 0 && renderPopularLinks(listItems)}
      </Grid>
    </Grid>
  );
});
PopularSearch.displayName = 'PopularSearch';

export default PopularSearch;
